module.exports = "<opi-slide-deck [slides]=\"slides\"></opi-slide-deck>";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.pug
// module id = 313
// module chunks = 1